
<section class="section_one">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <!-- desktop table view open-->
                <div class="ibox">
                    <div class="ibox-title report_flexweb">
                        <div>
                            <h5> View Course Track Name</h5>
                        </div>
                        <div class="icon_flex">
                            <div>
                                <button class="create" (click)="opendialog1()">Create Course Track </button>
                              </div>
                            <!-- <a href="#" class="dload_rpt"> <span><img
                                        src="../../assets/image/vscode-icons_file-type-excel.svg"
                                        alt=""></span>&nbsp;Export in Excel</a> -->
                       
                        <div class="dropdown">
                            <button class="dropdown-toggle month_dropshow" type="button" id="dropdownMenuButton"
                            data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <img src="../../../../../assets/image/Filter.svg.svg" alt="filter" class="cctv_filter">
                        </button>
                            <ul class="dropdown-menu dropdown-menu-right mis_select_show"
                            aria-labelledby="dropdownMenuButton">
                                <li><a (click)="pending( 'PENDING' )" class="dropdown-item">Pending</a></li>
                                <li><a  (click)="pending( 'REJECTED')" class="dropdown-item">Rejected</a></li>
                                <li><a (click)="pending('APPROVED')" class="dropdown-item">Approved</a></li>
                            </ul>
                        </div>
                        </div>
                     
                    </div>
                    <div class="ibox-content">
                        <div class="table-responsive">
                            <table id="example" class="table table-striped table-bordered" style="width:100%" *ngIf="table">
                                <thead>
                                    <tr>
                                    <th>Course Track</th>
                                    <th>Code</th>
                                    <th>Class</th>
                                    <th>Medium</th>
                                    <th>Group</th>
                                    <th>Orientation</th>
                                    <th style="width: 67.75px;">Track Typr</th>
                                    <th >Stream</th>
                                     <th>Coaching</th>
                                    <th>STATUS</th>
                                    <th style=" width: 67.2734px;">Created on</th>
                                    <th style=" width: 87.0799px;" >ApprovalStatus</th>
                                    <th>ActionStatus</th>
                                    <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let report of table">
                                        <td style="font-family: montserrat,sans-serif;">{{ report.courseTrackName|uppercase}}</td>
                                        <td style="font-family: montserrat,sans-serif;">{{ report.courseTrackCode|uppercase }}</td>
                                        <td style="font-family: montserrat,sans-serif;">{{ report.className|uppercase }}</td>
                                        <td style="font-family: montserrat,sans-serif;">{{ report.medium|uppercase }}</td>
                                        <td style="font-family: montserrat,sans-serif;">{{ report.groupName|uppercase}}</td>
                                        <td style="font-family: montserrat,sans-serif;">{{ report.orientation|uppercase }}</td>
                                        <td style="font-family: montserrat,sans-serif;">{{ report.trackType|uppercase}}</td>
                                        <td style="font-family: montserrat,sans-serif;">{{ report.streamName|uppercase }}</td>
                                        <td style="font-family: montserrat,sans-serif;">{{ report.coachingType|uppercase }}</td>
                                        <td style="font-family: montserrat,sans-serif;">{{ report.status}}</td>    
                                        <td style="font-family: montserrat,sans-serif;">{{ report.createdOn}}</td>  
                                        <td style=" width: 87.0799px;"  style="font-family: montserrat,sans-serif;">  
                                          
                                            <ng-container *ngIf="report.approvalStatus==='PENDING'">
                                                <span class="track_pending"><span></span>Pending</span>
                                            </ng-container>
                                            <ng-container *ngIf="report.approvalStatus==='APPROVED'">
                                                <span class="track_approve"><span></span>approved</span>
                                            </ng-container>
                                            <ng-container *ngIf="report.approvalStatus==='REJECTED'">
                                                <span class="track_reject"><span></span>rejected</span>
                                            </ng-container>
                                                                            
                                      
                                    </td> 
                                    <td><button class="view" (click)="openDialog(report)">view</button></td>
                                    <!-- <td>
                                        <img src="../../assets/image/circum_edit.svg"(click)="edit(report)" class="pointer" [attr.disabled]="report.approvalStatus === 'pending' ? true : null">
                                    </td> -->
                                    <td>
                                        <img src="../../assets/image/circum_edit.svg" 
                                             [class.disabled]="report.approvalStatus !== 'PENDING'"
                                             (click)="report.approvalStatus === 'PENDING' && edit(report)" 
                                             class="pointer"
                                             [class.disabled-image]="report.approvalStatus !== 'PENDING'">

                                    </td>
                                    
                                     </tr> 
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <!-- desktop table view close-->
            </div>
        </div>
    </div>
</section>




<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>



